/**
 * Empresa (tenant) con la que opera esta PWA en la edición online.
 *
 * En la edición offline el server local sirve a una sola empresa y esto no se
 * usa. En la online el backend es compartido: antes del login (selector de
 * cajeros, login admin) la PWA identifica la empresa por RUC con el header
 * `X-Tenant-Ruc`. Persistido para no pedirlo en cada turno.
 */

import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface CompanyState {
  ruc: string | null;
  setRuc: (ruc: string) => void;
  clear: () => void;
}

export const useCompanyStore = create<CompanyState>()(
  persist(
    (set) => ({
      ruc: null,
      setRuc: (ruc) => set({ ruc }),
      clear: () => set({ ruc: null }),
    }),
    {
      name: "sistema-sale-pos.company",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
